import { createStore, persist } from "easy-peasy";
import { StoreModel } from "app/state/api/interfaces";
// Explorer
import {
  IntercomUser,
  StripeBillingInfo,
  StripeInvoices,
  StripePaymentMethod,
  StripeSubscriptionPlan,
  updateUser,
  user,
  UserInvitations,
} from "app/state/api/action-reducers/auth/user";
import {
  ExplorerFeaturedFilters,
  ExplorerSearchActivities,
  ExplorerSearchLocations,
  ExplorerSearchOrganisations,
  ExplorerSearchSectors,
} from "app/state/api/action-reducers/explorer/search";
import { CMSData, ShowHeaderBanner } from "app/state/api/action-reducers/sync";
import { roles } from "app/state/api/action-reducers/auth/roles";
import componentsFooter from "app/state/api/action-reducers/cms/componentsFooter";
import { ConnectedAccounts } from "app/state/api/action-reducers/connected-accounts";
import { appliedFilters } from "app/state/api/action-reducers/explorer/appliedFilters";
import { ActiveHeaderButton } from "app/state/api/action-reducers/active-header-button";
import PublisherConvertedFiles from "app/state/api/action-reducers/publisher/convertedFiles";
import { ExplorerOverviewStats } from "app/state/api/action-reducers/explorer/overview-stats";
import PublisherConvertedFileActivities from "app/state/api/action-reducers/publisher/convertedFileActivities";
import PublisherConvertedFileValidationReport from "app/state/api/action-reducers/publisher/convertedFileValidationReport";
import {
  ExplorerSDGs,
  ExplorerHomeSDGs,
} from "app/state/api/action-reducers/explorer/sdgs";
import {
  ExplorerBudgetBySector,
  ExplorerHomeBudgetBySector,
} from "app/state/api/action-reducers/explorer/budget";
import {
  ExplorerActivityPage,
  ExplorerActivityPageOrganisations,
  ExplorerActivityPageRelatedActivities,
  ExplorerActivityPageResults,
  ExplorerActivityPageTransactions,
  ExplorerActivityPageTransactionsLineChart,
  ExplorerActivityTable,
  ExplorerHomeActivityTable,
  ExplorerMainActivityTable,
} from "app/state/api/action-reducers/explorer/activities";
import {
  ExplorerLocations,
  ExplorerLocationMap,
  ExplorerLocationsList,
  ExplorerLocationStats,
  ExplorerLocationPageMap,
  ExplorerLocationPageSDGs,
  ExplorerLocationOfTheMonth,
  ExplorerLocationPageSectors,
  ExplorerLocationPageActivityTable,
  ExplorerLocationPageOverviewStats,
  ExplorerLocationPageBudgetBySector,
  ExplorerLocationPageOrganisationsDonut,
  ExplorerLocationPageOrganisationsNetwork,
  ExplorerLocationsMap,
} from "app/state/api/action-reducers/explorer/locations";
import {
  ExplorerSectors,
  ExplorerSectorsList,
  ExplorerSectorStats,
  ExplorerHomeSectors,
  ExplorerSectorPageSDGs,
  ExplorerSectorPartners,
  ExplorerSectorOfTheMonth,
  ExplorerSectorPageLocations,
  ExplorerSectorPageOverviewStats,
  ExplorerSectorPageSectorFunding,
  ExplorerSectorPageActivityTable,
  ExplorerSectorOrganisationsDonut,
  ExplorerSectorOrganisationsNetwork,
  ExplorerSectorPageLocationsMap,
  ExplorerSectorPageSectorOverTheYears,
} from "app/state/api/action-reducers/explorer/sectors";
import {
  ExplorerOrganisationsList,
  ExplorerOrganisationStats,
  ExplorerOrganisationsDonut,
  ExplorerOrganisationSectors,
  ExplorerOrganisationsNetwork,
  ExplorerOrganisationPageSDGs,
  ExplorerOrganisationPartners,
  ExplorerHomeOrganisationsDonut,
  ExplorerOrganisationOfTheMonth,
  ExplorerHomeOrganisationsNetwork,
  ExplorerOrganisationPageLocations,
  ExplorerOrganisationPageDatasetTable,
  ExplorerOrganisationPageOverviewStats,
  ExplorerOrganisationPageActivityTable,
  ExplorerOrganisationOrganisationsNetwork,
  ExplorerOrganisationPageLocationsMap,
} from "app/state/api/action-reducers/explorer/organisations";
import {
  ExplorerActivityScopeFilterOptions,
  ExplorerActivityStatusFilterOptions,
  ExplorerCollaborationTypeFilterOptions,
  ExplorerCurrencyFilterOptions,
  ExplorerDefaultAidTypeFilterOptions,
  ExplorerDefaultAidTypeVocabularyFilterOptions,
  ExplorerDefaultFinanceTypeFilterOptions,
  ExplorerDefaultFlowTypeFilterOptions,
  ExplorerDefaultLanguageFilterOptions,
  ExplorerDefaultTiedStatusFilterOptions,
  ExplorerDocumentLinkCategoryFilterOptions,
  ExplorerHierarchyFilterOptions,
  ExplorerHumanitarianScopeTypeFilterOptions,
  ExplorerHumanitarianScopeVocabularyFilterOptions,
  ExplorerIATIVersionFilterOptions,
  ExplorerLocationFilterOptions,
  ExplorerOtherIdentifierTypeFilterOptions,
  ExplorerPolicyMarkerFilterOptions,
  ExplorerPublisherFilterOptions,
  ExplorerReportingOrganisationTypeFilterOptions,
  ExplorerSDGFilterOptions,
  ExplorerSectorsFilterOptions,
  ExplorerSectorVocabularyFilterOptions,
  ExplorerTagFilterOptions,
  ExplorerTransactionFlowTypeFilterOptions,
  ExplorerTransactionReceiverOrganisationFilterOptions,
  ExplorerTransactionTiedStatusFilterOptions,
  ExplorerTransactionValueCurrencyFilterOptions,
  ExplorerYearFilterOptions,
} from "app/state/api/action-reducers/explorer/filter-options";
import {
  ExplorerImpactResults,
  ExplorerSectorPageImpactResults,
  ExplorerLocationPageImpactResults,
  ExplorerOrganisationPageImpactResults,
} from "app/state/api/action-reducers/explorer/results";
import {
  GetBookmarks,
  CreateBookmark,
  DeleteBookmark,
  GetAlerts,
  CreateAlert,
  DeleteAlert,
  UpdateBookmark,
} from "app/state/api/action-reducers/auth/favourites";
import {
  createGroup,
  updateGroup,
  groupMembers,
} from "app/state/api/action-reducers/auth/groups";
import componentsHeader from "app/state/api/action-reducers/cms/componentsHeader";
import pagesAccountProfile from "app/state/api/action-reducers/cms/pagesAccountProfile";
import pagesDataHub from "app/state/api/action-reducers/cms/pagesDataHub";
import pagesDataServices from "app/state/api/action-reducers/cms/pagesDataServices";
import pagesExplorer from "app/state/api/action-reducers/cms/pagesExplorer";
import pagesExplorerActivities from "app/state/api/action-reducers/cms/pagesExplorerActivities";
import pagesExplorerFavourites from "app/state/api/action-reducers/cms/pagesExplorerFavourites";
import pagesExplorerLocations from "app/state/api/action-reducers/cms/pagesExplorerLocations";
import pagesExplorerOrganisations from "app/state/api/action-reducers/cms/pagesExplorerOrganisations";
import pagesExplorerSectors from "app/state/api/action-reducers/cms/pagesExplorerSectors";
import pagesLandingExplorer from "app/state/api/action-reducers/cms/pagesLandingExplorer";
import pagesLandingPublisher from "app/state/api/action-reducers/cms/pagesLandingPublisher";
import pagesLogin from "app/state/api/action-reducers/cms/pagesLogin";
import pagesPublisher from "app/state/api/action-reducers/cms/pagesPublisher";
import pagesPublisherPublish from "app/state/api/action-reducers/cms/pagesPublisherPublish";
import ctaFooter from "app/state/api/action-reducers/cms/ctaFooter";
import general from "app/state/api/action-reducers/cms/general";
import {
  DataHubSDGs,
  DataHubLocations,
  DataHubOverviewStats,
  DataHubImpactResults,
  DataHubBudgetBySector,
  DataHubPartnersNetwork,
  DataHubOrganisationsNetwork,
  DataHubLocationsMap,
} from "app/state/api/action-reducers/publisher/visualisations";
import { PlatformWalkthrough } from "../api/action-reducers/platform-walkthrough";
import componentsDetailPageNotFoundModal from "../api/action-reducers/cms/componentsDetailPageNotFoundModal";
import componentsGenericBlockItem from "../api/action-reducers/cms/componentsGenericBlockItem";
import pagesExplorerActivity from "../api/action-reducers/cms/pagesExplorerActivity";
import pagesExplorerLocation from "../api/action-reducers/cms/pagesExplorerLocation";
import pagesExplorerOrganisation from "../api/action-reducers/cms/pagesExplorerOrganisation";
import pagesExplorerSector from "../api/action-reducers/cms/pagesExplorerSector";

const storeContent: StoreModel = {
  // Explorer
  ExplorerSearchActivities: persist(ExplorerSearchActivities),
  ExplorerSearchLocations: persist(ExplorerSearchLocations),
  ExplorerSearchOrganisations: persist(ExplorerSearchOrganisations),
  ExplorerSearchSectors: persist(ExplorerSearchSectors),
  ExplorerOverviewStats: persist(ExplorerOverviewStats),
  ExplorerLocations: persist(ExplorerLocations),
  ExplorerLocationsMap: persist(ExplorerLocationsMap),
  ExplorerOrganisationsDonut: persist(ExplorerOrganisationsDonut),
  ExplorerSectors: persist(ExplorerSectors),
  ExplorerSDGs: persist(ExplorerSDGs),
  ExplorerBudgetBySector: persist(ExplorerBudgetBySector),
  ExplorerOrganisationsNetwork: persist(ExplorerOrganisationsNetwork),
  ExplorerImpactResults: persist(ExplorerImpactResults),
  ExplorerMainActivityTable: persist(ExplorerMainActivityTable),
  ExplorerLocationOfTheMonth: persist(ExplorerLocationOfTheMonth),
  ExplorerLocationStats: persist(ExplorerLocationStats),
  ExplorerLocationsList: persist(ExplorerLocationsList),
  ExplorerLocationMap: persist(ExplorerLocationMap),
  ExplorerOrganisationOfTheMonth: persist(ExplorerOrganisationOfTheMonth),
  ExplorerOrganisationStats: persist(ExplorerOrganisationStats),
  ExplorerOrganisationsList: persist(ExplorerOrganisationsList),
  ExplorerOrganisationPartners: persist(ExplorerOrganisationPartners),
  ExplorerSectorPartners: persist(ExplorerSectorPartners),
  ExplorerSectorOfTheMonth: persist(ExplorerSectorOfTheMonth),
  ExplorerSectorStats: persist(ExplorerSectorStats),
  ExplorerSectorsList: persist(ExplorerSectorsList),
  ExplorerActivityTable: ExplorerActivityTable,
  ExplorerLocationFilterOptions: persist(ExplorerLocationFilterOptions),
  ExplorerPublisherFilterOptions: persist(ExplorerPublisherFilterOptions),
  ExplorerSectorsFilterOptions: persist(ExplorerSectorsFilterOptions),
  ExplorerActivityStatusFilterOptions: persist(
    ExplorerActivityStatusFilterOptions
  ),
  ExplorerYearFilterOptions: persist(ExplorerYearFilterOptions),
  ExplorerSDGFilterOptions: persist(ExplorerSDGFilterOptions),
  ExplorerActivityScopeFilterOptions: persist(
    ExplorerActivityScopeFilterOptions
  ),
  ExplorerDocumentLinkCategoryFilterOptions: persist(
    ExplorerDocumentLinkCategoryFilterOptions
  ),
  ExplorerHierarchyFilterOptions: persist(ExplorerHierarchyFilterOptions),
  ExplorerHumanitarianScopeVocabularyFilterOptions: persist(
    ExplorerHumanitarianScopeVocabularyFilterOptions
  ),
  ExplorerHumanitarianScopeTypeFilterOptions: persist(
    ExplorerHumanitarianScopeTypeFilterOptions
  ),
  ExplorerIATIVersionFilterOptions: persist(ExplorerIATIVersionFilterOptions),
  ExplorerOtherIdentifierTypeFilterOptions: persist(
    ExplorerOtherIdentifierTypeFilterOptions
  ),
  ExplorerTagFilterOptions: persist(ExplorerTagFilterOptions),
  ExplorerDefaultAidTypeFilterOptions: persist(
    ExplorerDefaultAidTypeFilterOptions
  ),
  ExplorerDefaultAidTypeVocabularyFilterOptions: persist(
    ExplorerDefaultAidTypeVocabularyFilterOptions
  ),
  ExplorerCurrencyFilterOptions: persist(ExplorerCurrencyFilterOptions),
  ExplorerDefaultFinanceTypeFilterOptions: persist(
    ExplorerDefaultFinanceTypeFilterOptions
  ),
  ExplorerDefaultFlowTypeFilterOptions: persist(
    ExplorerDefaultFlowTypeFilterOptions
  ),
  ExplorerDefaultLanguageFilterOptions: persist(
    ExplorerDefaultLanguageFilterOptions
  ),
  ExplorerDefaultTiedStatusFilterOptions: persist(
    ExplorerDefaultTiedStatusFilterOptions
  ),
  ExplorerTransactionReceiverOrganisationFilterOptions: persist(
    ExplorerTransactionReceiverOrganisationFilterOptions
  ),
  ExplorerReportingOrganisationTypeFilterOptions: persist(
    ExplorerReportingOrganisationTypeFilterOptions
  ),
  ExplorerCollaborationTypeFilterOptions: persist(
    ExplorerCollaborationTypeFilterOptions
  ),
  ExplorerSectorVocabularyFilterOptions: persist(
    ExplorerSectorVocabularyFilterOptions
  ),
  ExplorerPolicyMarkerFilterOptions: persist(ExplorerPolicyMarkerFilterOptions),
  ExplorerTransactionFlowTypeFilterOptions: persist(
    ExplorerTransactionFlowTypeFilterOptions
  ),
  ExplorerTransactionTiedStatusFilterOptions: persist(
    ExplorerTransactionTiedStatusFilterOptions
  ),
  ExplorerTransactionValueCurrencyFilterOptions: persist(
    ExplorerTransactionValueCurrencyFilterOptions
  ),
  ExplorerFeaturedFilters: persist(ExplorerFeaturedFilters),
  // Explorer Home
  ExplorerHomeSDGs: persist(ExplorerHomeSDGs),
  ExplorerHomeBudgetBySector: persist(ExplorerHomeBudgetBySector),
  ExplorerHomeOrganisationsNetwork: persist(ExplorerHomeOrganisationsNetwork),
  ExplorerHomeSectors: persist(ExplorerHomeSectors),
  ExplorerHomeOrganisationsDonut: persist(ExplorerHomeOrganisationsDonut),
  ExplorerHomeActivityTable: persist(ExplorerHomeActivityTable),
  // Explorer Location Page
  ExplorerLocationPageOverviewStats: persist(ExplorerLocationPageOverviewStats),
  ExplorerLocationPageMap: persist(ExplorerLocationPageMap),
  ExplorerLocationPageSDGs: persist(ExplorerLocationPageSDGs),
  ExplorerLocationPageOrganisationsNetwork: persist(
    ExplorerLocationPageOrganisationsNetwork
  ),
  ExplorerLocationPageOrganisationsDonut: persist(
    ExplorerLocationPageOrganisationsDonut
  ),
  ExplorerLocationPageBudgetBySector: persist(
    ExplorerLocationPageBudgetBySector
  ),
  ExplorerLocationPageSectors: persist(ExplorerLocationPageSectors),
  ExplorerLocationPageImpactResults: persist(ExplorerLocationPageImpactResults),
  ExplorerLocationPageActivityTable: persist(ExplorerLocationPageActivityTable),
  // Explorer Organisation Page
  ExplorerOrganisationPageOverviewStats: persist(
    ExplorerOrganisationPageOverviewStats
  ),
  ExplorerOrganisationPageLocations: persist(ExplorerOrganisationPageLocations),
  ExplorerOrganisationPageLocationsMap: persist(
    ExplorerOrganisationPageLocationsMap
  ),
  ExplorerOrganisationPageSDGs: persist(ExplorerOrganisationPageSDGs),
  ExplorerOrganisationOrganisationsNetwork: persist(
    ExplorerOrganisationOrganisationsNetwork
  ),
  ExplorerOrganisationSectors: persist(ExplorerOrganisationSectors),
  ExplorerOrganisationPageImpactResults: persist(
    ExplorerOrganisationPageImpactResults
  ),
  ExplorerOrganisationPageActivityTable: persist(
    ExplorerOrganisationPageActivityTable
  ),
  ExplorerOrganisationPageDatasetTable: persist(
    ExplorerOrganisationPageDatasetTable
  ),
  // Explorer Sector Page
  ExplorerSectorPageOverviewStats: persist(ExplorerSectorPageOverviewStats),
  ExplorerSectorPageLocations: persist(ExplorerSectorPageLocations),
  ExplorerSectorPageLocationsMap: persist(ExplorerSectorPageLocationsMap),
  ExplorerSectorPageSDGs: persist(ExplorerSectorPageSDGs),
  ExplorerSectorOrganisationsNetwork: persist(
    ExplorerSectorOrganisationsNetwork
  ),
  ExplorerSectorPageSectorFunding: persist(ExplorerSectorPageSectorFunding),
  ExplorerSectorPageSectorOverTheYears: persist(
    ExplorerSectorPageSectorOverTheYears
  ),
  ExplorerSectorOrganisationsDonut: persist(ExplorerSectorOrganisationsDonut),
  ExplorerSectorPageImpactResults: persist(ExplorerSectorPageImpactResults),
  ExplorerSectorPageActivityTable: persist(ExplorerSectorPageActivityTable),
  // Explorer Activity Page
  ExplorerActivityPage: persist(ExplorerActivityPage),
  ExplorerActivityPageTransactions: persist(ExplorerActivityPageTransactions),
  ExplorerActivityPageTransactionsLineChart: persist(
    ExplorerActivityPageTransactionsLineChart
  ),
  ExplorerActivityPageOrganisations: persist(ExplorerActivityPageOrganisations),
  ExplorerActivityPageRelatedActivities: persist(
    ExplorerActivityPageRelatedActivities
  ),
  ExplorerActivityPageResults: persist(ExplorerActivityPageResults),
  // Publisher
  PublisherConvertedFiles: persist(PublisherConvertedFiles),
  PublisherConvertedFileActivities: persist(PublisherConvertedFileActivities),
  PublisherConvertedFileValidationReport: persist(
    PublisherConvertedFileValidationReport
  ),
  // Data Hub
  DataHubOverviewStats: persist(DataHubOverviewStats),
  DataHubLocations: persist(DataHubLocations),
  DataHubLocationsMap: persist(DataHubLocationsMap),
  DataHubSDGs: persist(DataHubSDGs),
  DataHubOrganisationsNetwork: persist(DataHubOrganisationsNetwork),
  DataHubImpactResults: persist(DataHubImpactResults),
  DataHubBudgetBySector: persist(DataHubBudgetBySector),
  DataHubPartnersNetwork: persist(DataHubPartnersNetwork),
  // Auth
  user: persist(user, { storage: "localStorage" }),
  updateUser: updateUser,
  updateGroup: updateGroup,
  createGroup: createGroup,
  groupMembers: groupMembers,
  roles: roles,
  IntercomUser: persist(IntercomUser, { storage: "localStorage" }),
  GetBookmarks: persist(GetBookmarks),
  CreateBookmark: persist(CreateBookmark),
  DeleteBookmark: persist(DeleteBookmark),
  UpdateBookmark: persist(UpdateBookmark),
  GetAlerts: persist(GetAlerts),
  CreateAlert: persist(CreateAlert),
  DeleteAlert: persist(DeleteAlert),
  StripeSubscriptionPlan: persist(StripeSubscriptionPlan),
  StripePaymentMethod: persist(StripePaymentMethod),
  StripeBillingInfo: persist(StripeBillingInfo),
  StripeInvoices: persist(StripeInvoices),
  userInvitations: persist(UserInvitations),
  // Drives
  connectedAccounts: ConnectedAccounts,
  activeHeaderButton: ActiveHeaderButton,
  platformWalkthrough: persist(PlatformWalkthrough, {
    storage: "localStorage",
  }),
  // CMS
  CMSData: persist(CMSData),
  cms: {
    componentsFooter: persist(componentsFooter),
    componentsHeader: persist(componentsHeader),
    componentsDetailPageNotFoundModal: persist(
      componentsDetailPageNotFoundModal
    ),
    componentsGenericBlockItem: persist(componentsGenericBlockItem),
    pagesLandingExplorer: persist(pagesLandingExplorer),
    pagesExplorerActivity: persist(pagesExplorerActivity),
    pagesExplorerLocation: persist(pagesExplorerLocation),
    pagesExplorerOrganisation: persist(pagesExplorerOrganisation),
    pagesExplorerSector: persist(pagesExplorerSector),
    pagesLandingPublisher: persist(pagesLandingPublisher),
    pagesAccountProfile: persist(pagesAccountProfile),
    pagesDataHub: persist(pagesDataHub),
    pagesDataServices: persist(pagesDataServices),
    pagesExplorer: persist(pagesExplorer),
    pagesExplorerLocations: persist(pagesExplorerLocations),
    pagesExplorerOrganisations: persist(pagesExplorerOrganisations),
    pagesExplorerSectors: persist(pagesExplorerSectors),
    pagesExplorerActivities: persist(pagesExplorerActivities),
    pagesExplorerFavourites: persist(pagesExplorerFavourites),
    pagesPublisher: persist(pagesPublisher),
    pagesPublisherPublish: persist(pagesPublisherPublish),
    pagesLogin: persist(pagesLogin),
    ctaFooter: persist(ctaFooter),
    general: persist(general),
  },
  showHeaderBanner: persist(ShowHeaderBanner, { storage: "sessionStorage" }),
  // Filters
  appliedFilters: persist(appliedFilters, { storage: "sessionStorage" }),
};

export const store = createStore(storeContent);
